import { useEffect, useState } from 'react';
/** Refresh visible funnel measurements when the analytics preference changes. */
export function useAnalyticsConsent(): number {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const update = () => setVersion((value) => value + 1);
    window.addEventListener('skytech-consent', update);
    return () => window.removeEventListener('skytech-consent', update);
  }, []);
  return version;
}
